<div class="canvas-layout drag-boundary">
  <div class="canvas-main">
    <div id="canvasContainer" style="position: relative; pointer-events: auto">
      <div id="konvaContainer" [ngStyle]="{ 'pointer-events': canDraw ? 'none' : 'auto' }"></div>
      <canvas height="600" width="800"></canvas>
    </div>
  </div>
  <div class="canvas-sidebar control-col">
    <div class="controls controls-layout">
      <div class="mouse-controls controls-col">
        <div class="">
          <button
            mat-icon-button
            (click)="toggleDraw(true)"
            [matTooltip]="'map.telestration.drawTool' | t"
            [class.active]="canDraw"
          >
            <sn-icon fontSet="fa-light" fontIcon="fa-pen"></sn-icon>
          </button>
          <button
            class="selectTool"
            mat-icon-button
            (click)="toggleDraw(false)"
            [matTooltip]="'map.telestration.selectTool' | t"
            [class.active]="!canDraw"
          >
            <sn-icon fontSet="fa-light" fontIcon="fa-arrow-pointer"></sn-icon>
          </button>
        </div>
        <form [formGroup]="form">
          <sn-color-picker-control
            name="activeColorSelector"
            ngDefaultControl
            [formControl]="formControlCanvas"
            [(value)]="activeColor"
          >
          </sn-color-picker-control>
        </form>
        <div id="stroke-controls">
          {{ 'map.telestration.lineThickness' | t }}: &nbsp;
          <mat-slider
            min="1"
            max="3"
            step="1"
            [(ngModel)]="lineMultiplier"
            name="lineMultiplier"
            (change)="updateLineWidth()"
          >
          </mat-slider>
        </div>
      </div>
      <div class="shapes controls-col">
        <mat-button-toggle-group>
          <mat-button-toggle [checked]="chosenType === 'basic'" (click)="setType('basic')"
            >{{ 'map.telestration.basic' | t }}</mat-button-toggle
          >
          <mat-button-toggle [checked]="chosenType === 'law'" (click)="setType('law')"
            >{{ 'map.telestration.lawEnforcement' | t }}
          </mat-button-toggle>
        </mat-button-toggle-group>
        <div class="shape-options">
          <h5>{{ 'map.telestration.dragAndDropToPlace' | t }}</h5>
          <div
            class="shape-control drag-control"
            *ngFor="let shape of shapes$ | async"
            [matTooltip]="getTranslatedShapeName(shape.shapeName)"
            cdkDrag
            cdkDragBoundary=".drag-boundary"
            (cdkDragReleased)="dragRelease(shape, $event)"
          >
            <svg
              viewBox="0 0 512 512"
              height="100%"
              width="100%"
              stroke-width="15"
              stroke="#FFF"
              fill="transparent"
              style="padding-right: 0.5rem"
            >
              <path attr.d="{{ shape.shapeIcon }}" />
            </svg>
          </div>
          <hr />
          <div
            class="icon-control drag-control"
            *ngFor="let icon of icons$ | async"
            [matTooltip]="getTranslatedIconLabel(icon.name)"
            cdkDrag
            cdkDragBoundary=".drag-boundary"
            (cdkDragReleased)="textRelease(icon, $event)"
          >
            <div class="outer-border">
              <span class="black-border">
                {{ icon.name }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <button mat-button color="warning" (click)="undo()">{{ 'common.undo' | t }}</button>
        <button mat-button color="warning" (click)="clear()">{{ 'common.clearAll' | t }}</button>
      </div>
    </div>
  </div>
</div>
